<div class="flex flex-row justify-start items-center checkbox-msg">
  <div class="icon-oval mr-16">
    <mat-icon svgIcon="done" class="icon-sm"></mat-icon>
  </div>
  <div class="fw-400">
    {{message}}
  </div>
</div>
